import { DatePresetType } from "../Pages/Trading/Filters/FilterField";

export function formatYMD(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export function getPresetRange(preset: DatePresetType): { start: string; end: string } {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (preset) {
        case "Today": {
            const s = formatYMD(today);
            return { start: s, end: s };
        }
        case "Yesterday": {
            const y = new Date(today);
            y.setDate(y.getDate() - 1);
            const s = formatYMD(y);
            return { start: s, end: s };
        }
        case "This Week": {
            const start = new Date(today);
            const day = start.getDay();
            const diff = day === 0 ? -6 : 1 - day;
            start.setDate(start.getDate() + diff);
            return { start: formatYMD(start), end: formatYMD(today) };
        }
        case "This Month": {
            const start = new Date(today.getFullYear(), today.getMonth(), 1);
            return { start: formatYMD(start), end: formatYMD(today) };
        }
        case "Previous Month": {
            const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const end = new Date(today.getFullYear(), today.getMonth(), 0);
            return { start: formatYMD(start), end: formatYMD(end) };
        }
        default:
            return { start: "", end: "" };
    }
}